import React from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import NavBar from "../NavBar";
import Footer from "../Footer";
import { DollarSign, Clock, Briefcase, Shield } from "lucide-react";
import "./index.css";

const Employment = () => {
  const [result, setResult] = React.useState("");
  const navigate = useNavigate(); // Initialize the useNavigate hook

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "d207344c-6399-4cd7-b920-5d196427385b");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      // Navigate to the Thank You page on success
      navigate("/thank-you");
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Join Our Team | Local Trash Pickup Service in Peoria, IL, and
          Surrounding Areas
        </title>
        <meta
          name="description"
          content="Get local trash pickup services tailored for apartment complexes in Peoria, IL. Enjoy stress-free waste collection for a cleaner living space."
        />
        <link
          rel="canonical"
          to="https://simpletrashsolutionsllc.com/employment"
        />
      </Helmet>
      <NavBar />
      <div className="employment-container">
        {/* Header */}
        <section className="employment-header">
          <div className="header-content">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="header-text"
            >
              <h1>Become a Subcontractor</h1>
              <p>Earn 80% of Settlement for Every Unit Serviced</p>
            </motion.div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="employment-benefits">
          <div className="benefits-grid">
            {[
              {
                icon: <DollarSign className="benefit-icon" />,
                title: "Competitive Pay",
                description:
                  "Earn 80% of the settlement for each unit serviced",
              },
              {
                icon: <Clock className="benefit-icon" />,
                title: "Flexible Work Opportunities",
                description:
                  "Take on as much or as little work as you'd like, depending on availability.",
              },
              {
                icon: <Briefcase className="benefit-icon" />,
                title: "Regular Work",
                description: "Consistent assignments in your local area",
              },
              {
                icon: <Shield className="benefit-icon" />,
                title: "Support",
                description: "Ongoing assistance and professional development",
              },
            ].map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.4 }}
                viewport={{ once: true }}
                className="benefit-card"
              >
                <div className="benefit-icon-container">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </motion.div>
            ))}
          </div>

          {/* Application Form */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="application-form"
          >
            <h2>Apply Now</h2>
            <form className="form-fields" onSubmit={onSubmit}>
              <div className="form-group">
                <label>Full Name</label>
                <input type="text" name="full_name" className="input-field" />
              </div>
              <div className="form-group">
                <label>Location</label>
                <input type="text" name="location" className="input-field" />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input type="tel" name="phone_number" className="input-field" />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" name="email" className="input-field" />
              </div>
              <div className="form-group">
                <label>Do you have a pickup truck?</label>
                <select className="input-field" name="have_pickup_truck">
                  <option value="">Please select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea
                  rows={4}
                  name="message"
                  className="input-field"
                  placeholder="Tell us about your experience and why you'd be a great fit"
                ></textarea>
              </div>
              <button type="submit" className="submit-btn" name="submit">
                Submit Application
              </button>
            </form>
            <span className="result-sending">{result}</span>
          </motion.div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Employment;
